module.exports = __webpack_public_path__ + "static/create-segment-d7711e38c39e42c820a4a036ac630ff2.png";